import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import s from './CadastroClientes.module.css';

// Perfis dinâmicos — cadastrados em Administrativo → Perfis de Usuário
const rotuloPerfil = p =>
  p.nome === 'admin' ? 'Administrador' : p.nome.charAt(0).toUpperCase() + p.nome.slice(1);

const FORM_VAZIO = {
  id: null, nome: '', email: '', telefone: '', senha: '', perfil: 'vendedor', inativo: false, exibir_pdv: false, comissao_pct: '',
  altera_manutencao_estoque: false, altera_financeiro: false, libera_estoque_insuficiente: false, libera_limite_credito: false, libera_cliente_inadimplente: false, libera_cancelar_mesa_itens: false, garcom: false, estoquista: false, fila_producao: false, comanda: false, pdv_mobile: false, pedido_mobile: false, sempre_pedir_login: false,
};

export default function CadastroUsuarios() {
  const [lista, setLista]         = useState([]);
  const [pos, setPos]             = useState(0);
  const [form, setForm]           = useState(FORM_VAZIO);
  const [orgsVinculadas, setOrgsVinculadas] = useState([]);
  const [orgsDisponiveis, setOrgsDisponiveis] = useState([]);
  const [contasCaixa, setContasCaixa] = useState([]);
  const [modo, setModo]           = useState('visualizar'); // 'visualizar'|'novo'|'editar'
  const [erro, setErro]           = useState('');
  const [salvando, setSalvando]   = useState(false);
  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const [lookupAberto, setLookupAberto] = useState(false);
  const [perfis, setPerfis]       = useState([]);

  const carregarLista = useCallback(async () => {
    try {
      const { data } = await api.get('/usuarios');
      setLista(data);
      return data;
    } catch { return []; }
  }, []);

  const carregarOrgsDisponiveis = useCallback(async () => {
    try {
      const { data } = await api.get('/organizacoes');
      setOrgsDisponiveis(Array.isArray(data) ? data : []);
    } catch { setOrgsDisponiveis([]); }
  }, []);

  const carregarContasCaixa = useCallback(async () => {
    try {
      const { data } = await api.get('/financeiro/contas');
      setContasCaixa((data || []).filter(c => c.tipo === 'caixa' && c.ativo));
    } catch { setContasCaixa([]); }
  }, []);

  useEffect(() => {
    carregarLista().then(data => {
      if (data.length > 0) carregarUsuario(data[0].id);
    });
    carregarOrgsDisponiveis();
    carregarContasCaixa();
    api.get('/perfis').then(r => setPerfis(r.data || [])).catch(() => setPerfis([]));
  }, []); // eslint-disable-line

  const carregarUsuario = async (id) => {
    try {
      const { data } = await api.get(`/usuarios/${id}`);
      setForm({ id: data.id, nome: data.nome, email: data.email, telefone: data.telefone || '', senha: '', perfil: data.perfil, inativo: !data.ativo, exibir_pdv: !!data.exibir_pdv, comissao_pct: data.comissao_pct ?? '', altera_manutencao_estoque: !!data.altera_manutencao_estoque, altera_financeiro: !!data.altera_financeiro, libera_estoque_insuficiente: !!data.libera_estoque_insuficiente, libera_limite_credito: !!data.libera_limite_credito, libera_cliente_inadimplente: !!data.libera_cliente_inadimplente, libera_cancelar_mesa_itens: !!data.libera_cancelar_mesa_itens, garcom: !!data.garcom, estoquista: !!data.estoquista, fila_producao: !!data.fila_producao, comanda: !!data.comanda, pdv_mobile: !!data.pdv_mobile, pedido_mobile: !!data.pedido_mobile, sempre_pedir_login: !!data.sempre_pedir_login });
      setOrgsVinculadas(data.organizacoes || []);
      setModo('visualizar');
      setErro('');
    } catch { setErro('Erro ao carregar usuário.'); }
  };

  const irParaPos = async (novaPos) => {
    if (lista.length === 0) return;
    const clamped = Math.max(0, Math.min(novaPos, lista.length - 1));
    setPos(clamped);
    await carregarUsuario(lista[clamped].id);
  };

  const handleNovo = () => {
    setForm(FORM_VAZIO);
    setOrgsVinculadas([]);
    setModo('novo');
    setErro('');
  };

  const handleAlterar = () => {
    if (!form.id) return;
    setModo('editar');
    setErro('');
  };

  const handleCancelar = async () => {
    setErro('');
    if (form.id) { await carregarUsuario(form.id); }
    else if (lista.length > 0) { await carregarUsuario(lista[0].id); setPos(0); }
    setModo('visualizar');
  };

  const handleSalvar = async () => {
    setErro('');
    const faltando = [!form.nome?.trim() && 'Nome', !form.email?.trim() && 'E-mail', modo === 'novo' && !form.senha && 'Senha'].filter(Boolean);
    if (faltando.length) {
      const msg = `Preencha: ${faltando.join(', ')}.`;
      setErro(msg);
      alert(`Usuário NÃO foi salvo. ${msg}`);
      return;
    }
    setSalvando(true);
    try {
      let usuario;
      if (modo === 'novo') {
        const { data } = await api.post('/usuarios', {
          nome: form.nome, email: form.email, telefone: form.telefone, senha: form.senha, perfil: form.perfil,
          exibir_pdv: form.exibir_pdv, altera_manutencao_estoque: form.altera_manutencao_estoque, altera_financeiro: form.altera_financeiro,
          libera_estoque_insuficiente: form.libera_estoque_insuficiente, libera_limite_credito: form.libera_limite_credito, libera_cliente_inadimplente: form.libera_cliente_inadimplente, libera_cancelar_mesa_itens: form.libera_cancelar_mesa_itens, garcom: form.garcom, estoquista: form.estoquista, fila_producao: form.fila_producao, comanda: form.comanda, pdv_mobile: form.pdv_mobile, pedido_mobile: form.pedido_mobile, sempre_pedir_login: form.sempre_pedir_login,
          comissao_pct: form.comissao_pct === '' ? 0 : parseFloat(form.comissao_pct),
        });
        usuario = data;
      } else {
        const body = { nome: form.nome, email: form.email, telefone: form.telefone, perfil: form.perfil, inativo: form.inativo, exibir_pdv: form.exibir_pdv, altera_manutencao_estoque: form.altera_manutencao_estoque, altera_financeiro: form.altera_financeiro, libera_estoque_insuficiente: form.libera_estoque_insuficiente, libera_limite_credito: form.libera_limite_credito, libera_cliente_inadimplente: form.libera_cliente_inadimplente, libera_cancelar_mesa_itens: form.libera_cancelar_mesa_itens, garcom: form.garcom, estoquista: form.estoquista, fila_producao: form.fila_producao, comanda: form.comanda, pdv_mobile: form.pdv_mobile, pedido_mobile: form.pedido_mobile, sempre_pedir_login: form.sempre_pedir_login, comissao_pct: form.comissao_pct === '' ? null : parseFloat(form.comissao_pct) };
        if (form.senha) body.senha = form.senha;
        const { data } = await api.put(`/usuarios/${form.id}`, body);
        usuario = data;
      }

      // Salva organizações vinculadas
      await api.put(`/usuarios/${usuario.id}/organizacoes`, {
        organizacoes: orgsVinculadas.map(o => ({
          organizacao_id:    o.organizacao_id,
          organizacao_padrao: o.organizacao_padrao,
          ativo:             o.ativo !== false,
          conta_caixa_padrao_id: o.conta_caixa_padrao_id || null,
        })),
      });

      const novaLista = await carregarLista();
      const novoIdx  = novaLista.findIndex(u => u.id === usuario.id);
      setPos(novoIdx >= 0 ? novoIdx : 0);
      await carregarUsuario(usuario.id);
      setModo('visualizar');
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao salvar.';
      setErro(msg);
      alert(`Usuário NÃO foi salvo. ${msg}`);
    } finally { setSalvando(false); }
  };

  const handleExcluir = async () => {
    if (!form.id || !window.confirm(`Desativar o usuário "${form.nome}"?`)) return;
    try {
      await api.delete(`/usuarios/${form.id}`);
      const novaLista = await carregarLista();
      if (novaLista.length > 0) { setPos(0); await carregarUsuario(novaLista[0].id); }
      else { setForm(FORM_VAZIO); setOrgsVinculadas([]); }
    } catch (err) { setErro(err.response?.data?.erro || 'Erro ao excluir.'); }
  };

  const set = (field, val) => setForm(prev => ({ ...prev, [field]: val }));

  // ── Gestão de orgs vinculadas ────────────────────────────────
  const adicionarOrg = (org) => {
    if (orgsVinculadas.some(o => o.organizacao_id === org.id)) return;
    const ehPrimeira = orgsVinculadas.length === 0;
    setOrgsVinculadas(prev => [...prev, {
      organizacao_id:    org.id,
      razao_social:      org.razao_social,
      cnpj:              org.cnpj,
      organizacao_padrao: ehPrimeira,
      ativo:             true,
    }]);
    setLookupAberto(false);
  };

  const removerOrg = (orgId) => {
    setOrgsVinculadas(prev => {
      const nova = prev.filter(o => o.organizacao_id !== orgId);
      // Se removeu o padrão, marca a primeira como padrão
      if (!nova.some(o => o.organizacao_padrao) && nova.length > 0)
        nova[0] = { ...nova[0], organizacao_padrao: true };
      return nova;
    });
  };

  const setPadrao = (orgId) => {
    setOrgsVinculadas(prev => prev.map(o => ({ ...o, organizacao_padrao: o.organizacao_id === orgId })));
  };

  const toggleAtivoOrg = (orgId) => {
    setOrgsVinculadas(prev => prev.map(o =>
      o.organizacao_id === orgId ? { ...o, ativo: !o.ativo } : o
    ));
  };

  const setContaCaixaPadrao = (orgId, contaId) => {
    setOrgsVinculadas(prev => prev.map(o =>
      o.organizacao_id === orgId ? { ...o, conta_caixa_padrao_id: contaId ? Number(contaId) : null } : o
    ));
  };

  const somenteLeitura = modo === 'visualizar';

  // Atalhos de teclado — mesmo esquema das demais telas de cadastro
  // (Clientes/Produtos/Usuários): F2 Alterar, F4 Novo, F8 Excluir,
  // F9 Salvar, Esc Cancelar (sem F3/Buscar aqui — não tem modal de busca).
  useEffect(() => {
    const handler = (e) => {
      if (lookupAberto) return;
      if (e.key === 'F4' && somenteLeitura) { e.preventDefault(); handleNovo(); return; }
      if (e.key === 'F2' && somenteLeitura && form.id) { e.preventDefault(); handleAlterar(); return; }
      if (e.key === 'F8' && somenteLeitura && form.id) { e.preventDefault(); handleExcluir(); return; }
      if (e.key === 'F9' && !somenteLeitura && !salvando) { e.preventDefault(); handleSalvar(); return; }
      if (e.key === 'Escape' && !somenteLeitura) { e.preventDefault(); handleCancelar(); return; }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [somenteLeitura, form.id, lookupAberto, salvando]); // eslint-disable-line

  return (
    <div className={s.erpWrap}>
      {/* Title bar */}
      <div className={s.titleBar}>
        <span>Cadastro de Usuários</span>
      </div>

      {/* Header row */}
      <div className={s.headerRow}>
        <div className={s.headerGroup}>
          <span className={s.headerLabel}>Código</span>
          <input className={s.inputErp} style={{ width: 70 }} readOnly value={form.id || ''} />
        </div>
        <div className={s.headerGroup} style={{ flex: 1 }}>
          <span className={s.headerLabel}>Nome</span>
          <input
            className={s.inputErp}
            style={{ flex: 1 }}
            readOnly={somenteLeitura}
            value={form.nome}
            onChange={e => set('nome', e.target.value)}
          />
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}>
          <input
            type="checkbox"
            id="chkInativo"
            checked={form.inativo}
            disabled={somenteLeitura}
            onChange={e => set('inativo', e.target.checked)}
          />
          <label htmlFor="chkInativo">Inativo</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Aparece na escolha de vendedor ao finalizar a venda no PDV (comissão)">
          <input
            type="checkbox"
            id="chkExibirPdv"
            checked={form.exibir_pdv}
            disabled={somenteLeitura}
            onChange={e => set('exibir_pdv', e.target.checked)}
          />
          <label htmlFor="chkExibirPdv">Exibir no PDV</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Permite usar o botão Alterar numa contagem de estoque já confirmada (a alteração sempre exige senha de admin/gerente na hora de salvar)">
          <input
            type="checkbox"
            id="chkAlteraManutencao"
            checked={form.altera_manutencao_estoque}
            disabled={somenteLeitura}
            onChange={e => set('altera_manutencao_estoque', e.target.checked)}
          />
          <label htmlFor="chkAlteraManutencao">Altera Manutenção de Estoque</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Permite alterar/excluir um lançamento manual em Financeiro → Movimentações (a ação sempre exige senha de admin/gerente na hora de salvar)">
          <input
            type="checkbox"
            id="chkAlteraFinanceiro"
            checked={form.altera_financeiro}
            disabled={somenteLeitura}
            onChange={e => set('altera_financeiro', e.target.checked)}
          />
          <label htmlFor="chkAlteraFinanceiro">Altera/Exclui Financeiro</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Com a rotina 'Validar estoque insuficiente' ativa (Parâmetros → Rotinas), este usuário pode finalizar vendas com estoque negativo sem precisar de senha de admin/gerente">
          <input
            type="checkbox"
            id="chkLiberaEstoque"
            checked={form.libera_estoque_insuficiente}
            disabled={somenteLeitura}
            onChange={e => set('libera_estoque_insuficiente', e.target.checked)}
          />
          <label htmlFor="chkLiberaEstoque">Libera Estoque Insuficiente</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Com a rotina 'Validar limite de crédito' ativa (Parâmetros → Rotinas), este usuário pode finalizar vendas a prazo acima do limite de crédito do cliente sem precisar de senha de admin/gerente">
          <input
            type="checkbox"
            id="chkLiberaLimiteCredito"
            checked={form.libera_limite_credito}
            disabled={somenteLeitura}
            onChange={e => set('libera_limite_credito', e.target.checked)}
          />
          <label htmlFor="chkLiberaLimiteCredito">Libera Limite de Crédito</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Com a rotina 'Validar atraso do cliente' ativa (Parâmetros → Rotinas), este usuário pode finalizar vendas a prazo para clientes com boletos/crediários vencidos sem precisar de senha de admin/gerente">
          <input
            type="checkbox"
            id="chkLiberaInadimplente"
            checked={form.libera_cliente_inadimplente}
            disabled={somenteLeitura}
            onChange={e => set('libera_cliente_inadimplente', e.target.checked)}
          />
          <label htmlFor="chkLiberaInadimplente">Libera Cliente Inadimplente</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Permite cancelar uma mesa/comanda que já tem item(ns) lançado(s) sem precisar de senha de admin/gerente (mesa sem nenhum item cancela direto, sem precisar dessa liberação)">
          <input
            type="checkbox"
            id="chkLiberaCancelarMesa"
            checked={form.libera_cancelar_mesa_itens}
            disabled={somenteLeitura}
            onChange={e => set('libera_cancelar_mesa_itens', e.target.checked)}
          />
          <label htmlFor="chkLiberaCancelarMesa">Cancela Mesa com Itens</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Login cai direto em Mesas/Comandas — no desktop já abre o PDV com o F1 aberto, pelo celular vai pra uma tela simplificada só de mesas/comandas">
          <input
            type="checkbox"
            id="chkGarcom"
            checked={form.garcom}
            disabled={somenteLeitura}
            onChange={e => set('garcom', e.target.checked)}
          />
          <label htmlFor="chkGarcom">Garçom</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Login pelo celular/tablet cai direto numa tela de Reposição de Mercadoria: lê código de barras, guia quantidade → custo → venda item a item, e ao salvar gera uma Manutenção de Estoque (motivo digitado na hora). Código não cadastrado pede um cadastro rápido do produto na hora.">
          <input
            type="checkbox"
            id="chkEstoquista"
            checked={form.estoquista}
            disabled={somenteLeitura}
            onChange={e => set('estoquista', e.target.checked)}
          />
          <label htmlFor="chkEstoquista">Estoquista/Repositor</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Ignora a sessão padrão do dispositivo — este usuário sempre precisa digitar usuário e senha ao abrir o sistema, mesmo com o app instalado/fechado e reaberto (indicado para terminais/PCs compartilhados)">
          <input
            type="checkbox"
            id="chkSemprePedirLogin"
            checked={form.sempre_pedir_login}
            disabled={somenteLeitura}
            onChange={e => set('sempre_pedir_login', e.target.checked)}
          />
          <label htmlFor="chkSemprePedirLogin">Sempre Pedir Login</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Login cai direto na Fila de Produção (tela da cozinha, acompanha e finaliza os pedidos). Exclusivo com 'Comanda' — marcar este desmarca aquele.">
          <input
            type="checkbox"
            id="chkFilaProducao"
            checked={form.fila_producao}
            disabled={somenteLeitura}
            onChange={e => setForm(prev => ({ ...prev, fila_producao: e.target.checked, comanda: e.target.checked ? false : prev.comanda }))}
          />
          <label htmlFor="chkFilaProducao">Fila de Produção</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Login cai direto em Mesas/Comandas simplificado pra celular/tablet, pronto pra lançar pedido (mesma tela do Garçom). Exclusivo com 'Fila de Produção' — marcar este desmarca aquele.">
          <input
            type="checkbox"
            id="chkComanda"
            checked={form.comanda}
            disabled={somenteLeitura}
            onChange={e => setForm(prev => ({ ...prev, comanda: e.target.checked, fila_producao: e.target.checked ? false : prev.fila_producao }))}
          />
          <label htmlFor="chkComanda">Comanda</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Pelo celular, o login cai direto num PDV simplificado (vender, receber e compartilhar o comprovante pelo WhatsApp). No computador continua abrindo o sistema normal. A venda entra no caixa padrão deste usuário (Organizações Vinculadas).">
          <input
            type="checkbox"
            id="chkPdvMobile"
            checked={form.pdv_mobile}
            disabled={somenteLeitura}
            onChange={e => set('pdv_mobile', e.target.checked)}
          />
          <label htmlFor="chkPdvMobile">PDV Mobile</label>
        </div>
        <div className={s.checkRow} style={{ marginLeft: 16, alignSelf: 'flex-end', paddingBottom: 4 }}
          title="Pelo celular, o login cai direto em Pedidos/Orçamentos simplificado (montar, aprovar e enviar pelo WhatsApp). No computador continua abrindo o sistema normal.">
          <input
            type="checkbox"
            id="chkPedidoMobile"
            checked={form.pedido_mobile}
            disabled={somenteLeitura}
            onChange={e => set('pedido_mobile', e.target.checked)}
          />
          <label htmlFor="chkPedidoMobile">Pedido Mobile</label>
        </div>
        <div className={s.headerGroup} style={{ marginLeft: 16, width: 120 }}
          title="Usado quando Parâmetros → Rotinas → Pagamento de Comissão está com o percentual 'Por vendedor' — cada item da venda grava este %">
          <span className={s.headerLabel}>Comissão %</span>
          <input
            className={s.inputErp}
            type="number" min="0" max="100" step="0.01"
            readOnly={somenteLeitura}
            value={form.comissao_pct}
            onChange={e => set('comissao_pct', e.target.value)}
          />
        </div>
      </div>

      {/* Body */}
      <div className={s.tabContent} style={{ flex: 1, overflowY: 'auto', padding: '12px 16px' }}>
        {erro && (
          <div style={{ background: '#fdecea', color: '#c62828', padding: '6px 10px', borderRadius: 3, marginBottom: 10, fontSize: 12 }}>
            {erro}
          </div>
        )}

        {/* Dados principais */}
        <div className={s.fieldset} style={{ marginBottom: 14 }}>
          <div className={s.legend}>Dados de Acesso</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', padding: '8px 10px' }}>
            <div className={s.campo}>
              <span className={s.campoLabel}>E-mail</span>
              <input
                className={s.inputErp}
                type="email"
                autoComplete="off"
                readOnly={somenteLeitura}
                value={form.email}
                onChange={e => set('email', e.target.value)}
              />
            </div>
            <div className={s.campo}>
              <span className={s.campoLabel}>Telefone/Celular</span>
              <input
                className={s.inputErp}
                readOnly={somenteLeitura}
                value={form.telefone}
                placeholder="Sai na assinatura da Proposta Comercial"
                onChange={e => set('telefone', e.target.value)}
              />
            </div>
            <div className={s.campo}>
              <span className={s.campoLabel}>Perfil</span>
              <select
                className={s.selectErp}
                disabled={somenteLeitura}
                value={form.perfil}
                onChange={e => set('perfil', e.target.value)}
              >
                {/* Usuário com perfil que foi excluído/renomeado: mantém visível */}
                {form.perfil && !perfis.some(p => p.nome === form.perfil) && (
                  <option value={form.perfil}>{form.perfil} (perfil não cadastrado)</option>
                )}
                {perfis.map(p => (
                  <option key={p.id} value={p.nome} title={p.descricao || ''}>{rotuloPerfil(p)}</option>
                ))}
              </select>
            </div>
            <div className={s.campo}>
              <span className={s.campoLabel}>
                {modo === 'novo' ? 'Senha' : 'Nova Senha (deixe em branco para não alterar)'}
              </span>
              <div style={{ display: 'flex', gap: 4 }}>
                <input
                  className={s.inputErp}
                  style={{ flex: 1 }}
                  type={senhaVisivel ? 'text' : 'password'}
                  autoComplete="new-password"
                  readOnly={somenteLeitura}
                  value={form.senha}
                  onChange={e => set('senha', e.target.value)}
                  placeholder={modo === 'editar' ? '(sem alteração)' : ''}
                />
                {!somenteLeitura && (
                  <button
                    type="button"
                    className={s.btnLookup}
                    style={{ minWidth: 32 }}
                    onClick={() => setSenhaVisivel(v => !v)}
                    title={senhaVisivel ? 'Ocultar senha' : 'Mostrar senha'}
                  >
                    {senhaVisivel ? '🙈' : '👁️'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Organizações vinculadas */}
        <div className={s.fieldset}>
          <div className={s.legend}>Organizações Vinculadas</div>
          <div style={{ padding: '8px 10px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#d4d0c8' }}>
                  <th style={{ padding: '3px 6px', textAlign: 'left', border: '1px solid #999' }}>Organização</th>
                  <th style={{ padding: '3px 6px', textAlign: 'left', border: '1px solid #999', width: 160 }}>CNPJ</th>
                  <th style={{ padding: '3px 6px', textAlign: 'center', border: '1px solid #999', width: 60 }}>Padrão</th>
                  <th style={{ padding: '3px 6px', textAlign: 'center', border: '1px solid #999', width: 50 }}>Ativo</th>
                  <th style={{ padding: '3px 6px', textAlign: 'left', border: '1px solid #999', width: 160 }}
                    title="Ao abrir turno no PDV, já vem pré-selecionado este caixa">Caixa Padrão</th>
                  {!somenteLeitura && <th style={{ width: 30, border: '1px solid #999' }}></th>}
                </tr>
              </thead>
              <tbody>
                {orgsVinculadas.length === 0 && (
                  <tr>
                    <td colSpan={somenteLeitura ? 5 : 6} style={{ textAlign: 'center', color: '#888', padding: 8, border: '1px solid #ccc' }}>
                      Nenhuma organização vinculada
                    </td>
                  </tr>
                )}
                {orgsVinculadas.map(o => (
                  <tr key={o.organizacao_id} style={{ background: '#fff' }}>
                    <td style={{ padding: '3px 6px', border: '1px solid #ccc' }}>{o.razao_social}</td>
                    <td style={{ padding: '3px 6px', border: '1px solid #ccc', fontFamily: 'monospace' }}>{o.cnpj || '—'}</td>
                    <td style={{ padding: '3px 6px', border: '1px solid #ccc', textAlign: 'center' }}>
                      <input
                        type="radio"
                        name="orgPadrao"
                        checked={!!o.organizacao_padrao}
                        disabled={somenteLeitura}
                        onChange={() => setPadrao(o.organizacao_id)}
                      />
                    </td>
                    <td style={{ padding: '3px 6px', border: '1px solid #ccc', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={o.ativo !== false}
                        disabled={somenteLeitura}
                        onChange={() => toggleAtivoOrg(o.organizacao_id)}
                      />
                    </td>
                    <td style={{ padding: '3px 6px', border: '1px solid #ccc' }}>
                      {somenteLeitura ? (o.conta_caixa_padrao_nome || '—') : (
                        <select
                          className={s.selectErp}
                          style={{ width: '100%' }}
                          value={o.conta_caixa_padrao_id || ''}
                          onChange={e => setContaCaixaPadrao(o.organizacao_id, e.target.value)}
                        >
                          <option value="">— nenhum —</option>
                          {contasCaixa.map(c => (
                            <option key={c.id} value={c.id}>{c.nome}</option>
                          ))}
                        </select>
                      )}
                    </td>
                    {!somenteLeitura && (
                      <td style={{ padding: '3px 6px', border: '1px solid #ccc', textAlign: 'center' }}>
                        <button
                          className={s.btnLookup}
                          style={{ minWidth: 22, padding: '1px 5px', color: '#c00' }}
                          onClick={() => removerOrg(o.organizacao_id)}
                          title="Remover"
                        >✕</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {!somenteLeitura && (
              <div style={{ marginTop: 8, position: 'relative' }}>
                <button className={s.btnErp} onClick={() => setLookupAberto(v => !v)}>
                  + Adicionar Organização
                </button>
                {lookupAberto && (
                  <div style={{
                    position: 'absolute', top: '100%', left: 0, zIndex: 200,
                    background: '#fff', border: '2px solid #0a3a8c',
                    boxShadow: '3px 3px 10px rgba(0,0,0,0.3)',
                    minWidth: 340, maxHeight: 200, overflowY: 'auto',
                  }}>
                    {orgsDisponiveis
                      .filter(o => !orgsVinculadas.some(v => v.organizacao_id === o.id))
                      .map(o => (
                        <div
                          key={o.id}
                          style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12 }}
                          onMouseEnter={e => e.currentTarget.style.background = '#cce4ff'}
                          onMouseLeave={e => e.currentTarget.style.background = ''}
                          onClick={() => adicionarOrg(o)}
                        >
                          <strong>{o.razao_social}</strong>
                          {o.cnpj && <span style={{ color: '#666', marginLeft: 8, fontFamily: 'monospace' }}>{o.cnpj}</span>}
                        </div>
                      ))
                    }
                    {orgsDisponiveis.filter(o => !orgsVinculadas.some(v => v.organizacao_id === o.id)).length === 0 && (
                      <div style={{ padding: '8px 10px', color: '#888', fontSize: 12 }}>Todas as organizações já vinculadas</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Status bar */}
      <div className={s.statusBar}>
        <span className={modo === 'novo' ? s.statusNovo : modo === 'editar' ? s.statusEditar : ''}>
          {modo === 'novo' ? 'Novo registro' : modo === 'editar' ? 'Editando' : form.id ? `Usuário #${form.id}` : ''}
        </span>
      </div>

      {/* Footer */}
      <div className={s.footer}>
        <div className={s.footerLeft}>
          <button className={`${s.btnErp} ${s.btnErpNav}`} onClick={() => irParaPos(0)} disabled={modo !== 'visualizar'}>|◄</button>
          <button className={`${s.btnErp} ${s.btnErpNav}`} onClick={() => irParaPos(pos - 1)} disabled={modo !== 'visualizar'}>◄</button>
          <span className={s.footerPos}>{lista.length > 0 ? `${pos + 1} / ${lista.length}` : '0 / 0'}</span>
          <button className={`${s.btnErp} ${s.btnErpNav}`} onClick={() => irParaPos(pos + 1)} disabled={modo !== 'visualizar'}>►</button>
          <button className={`${s.btnErp} ${s.btnErpNav}`} onClick={() => irParaPos(lista.length - 1)} disabled={modo !== 'visualizar'}>►|</button>
        </div>
        <div className={s.footerSep} />
        <div className={s.footerRight}>
          <button className={s.btnErp} onClick={handleNovo} disabled={modo !== 'visualizar'}>Novo (F4)</button>
          <button className={s.btnErp} onClick={handleAlterar} disabled={modo !== 'visualizar' || !form.id}>Alterar (F2)</button>
          <button className={s.btnErp} onClick={handleCancelar} disabled={modo === 'visualizar'}>Cancelar (Esc)</button>
          <button className={s.btnErp} onClick={handleExcluir} disabled={modo !== 'visualizar' || !form.id}>Excluir (F8)</button>
          <button
            className={`${s.btnErp} ${s.btnErpPrimario}`}
            onClick={handleSalvar}
            disabled={modo === 'visualizar' || salvando}
          >
            {salvando ? 'Salvando...' : 'Salvar (F9)'}
          </button>
          <div className={s.footerSep} />
          <button className={s.btnErp}>Sair</button>
        </div>
      </div>
    </div>
  );
}
